import React, { useState } from 'react';
import Colours from './Colours';
import ColourPicker from '../ColourPicker';
import { useDocumentTitle } from "../../hooks/setDocumentTitle"

export default function ColourSuggestor() {
    const [selectedColours, setSelectedColours] = useState({});
    const [suggestions, setSuggestions] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useDocumentTitle("Colour Suggestor | Witty Crafts Design");

    function handleSelectedColourChange(event) {
        let temp = { ...selectedColours };
        temp[event.target.name] = event.target.value;
        setSelectedColours(temp);
    }

    async function clearSuggestions() {
        setSelectedColours(null);
        setSuggestions(null);
        setError(null);
    }

    async function getSuggestions() {
        if (selectedColours.length === 0) {
            setError('Select at least one colour');
            return;
        }

        setLoading(true);
        setError(null);
        setSuggestions(null);

        try {
            const nonEmptyColoursTemp = Object.values(selectedColours).filter(el => {
                return el !== '';
            });

            const res = await fetch('/api/ColourSuggest', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ SelectedColours: nonEmptyColoursTemp })
            });

            if (!res.ok) throw new Error(`Request failed: ${res.status}`);

            const data = await res.json();
            // data expected to be array of { name, colours }
            setSuggestions(data);
        } catch (e) {
            setError(e.message || 'Failed to fetch suggestions');
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div className="text-start">
                <h1>Colour Suggestor</h1>
                <div className="row">
                {Array.from(Array(8), (_, index) => index + 1).map(i =>
                    <div key={i} className="col-md col-6 text-center">
                        <label className="form-label fw-bold" htmlFor={`Colour${i}`}>Colour {i}</label>
                        <ColourPicker key={`Colour${i}`} name={`Colour${i}`} onChange={handleSelectedColourChange} />
                    </div>
                )}

                <div className="col-12 mt-2">
                    <div className="input-group">
                        <button onClick={getSuggestions} disabled={loading} className="btn btn-primary">Get suggestions</button>
                        {/*<button onClick={clearSuggestions} className="btn btn-secondary">Clear</button>*/}
                    </div>
                </div>


                {loading && <p>Loading...</p>}
                {error && <p style={{ color: 'crimson' }}>{error}</p>}

                {suggestions && (
                    <>
                        {suggestions.map((s, idx) => (
                        <div key={idx} className="row mt-2">
                            <h4>{s.name}</h4>
                            {s.colours.map((h, i) => (
                                <div key={i} className="col-md-2 col-6 text-center">
                                    <div className="colour-picker" style={{ backgroundColor: h.hex }}></div>
                                    <span>{h.name} {h.code}</span>
                                </div>
                            ))}
                        </div>
                        ))}
                    </>
                )}
                </div>
            </div>
        </>
    );
}
